import api from '../../../auth/apiClient';
import { getOdooVsSaktiEndpoint } from '../apiConfig';
import type { OdooVsSaktiResponse, OdooVsSaktiFilters } from '../types';

export class OdooVsSaktiService {
    static async getBkmVsSakti(filters: OdooVsSaktiFilters): Promise<OdooVsSaktiResponse> {
        const endpoint = getOdooVsSaktiEndpoint('BKM_VS_SAKTI');
        const response = await api.get<OdooVsSaktiResponse>(endpoint, {
            params: filters,
        });
        return response.data;
    }
}
